import React, { useState, useEffect } from "react";
import { Button, Modal, ModalHeader, ModalBody, ModalFooter } from "reactstrap";
import Select, { OptionProps, components } from "react-select";
import { returnInputFieldLength } from "../../../../utils/commonFunctions";
import Checkbox from "../../../commons/Checkbox";
import RadioContainer from "../../../commons/Radio/RadioContainer";
import { connect } from "react-redux";
import { RootState } from "../../../../redux/rootReducers";
import {
  GetAllStocksGroupPayloadType,
  getAllTypesParentStockGroupType,
} from "../../../../commonTypes/clientSettingsTypes";
import {
  getAllTypesParentStockGroupAction,
  resetStockGroupList,
} from "../../../../redux/clientSettings";
type AppProps = {
  isOpen?: boolean;
  client_code?: number | null;
  editStockGroupDetailsData?: any;
  isEdit?: boolean;
  stockGroupName?: string;
  stockGroupNameError?: string;
  handleAddStockGroupDetails: (data: any) => void;
  handleEditStockGroupDetails: (data: any) => void;
  handleResetEditData: () => void;
  toggleAddStockGroupModals: () => void;
  dispatchGetListStockGroup: (data: GetAllStocksGroupPayloadType) => void;
  token: string | null;
  stockGroupList: any;
  dispatchResetGroupList: () => void;
};

type RadioTypes = {
  id: string;
  name: string;
};

const RADIO_OPTIONS: RadioTypes[] = [
  {
    id: "1",
    name: "Yes",
  },
  {
    id: "0",
    name: "No",
  },
];

type clientListType = {
  value: string | undefined | null;
  label: string | undefined | null;
};

const AddEditStockGroupModal = ({
  isOpen,
  client_code,
  isEdit,
  stockGroupName,
  stockGroupNameError,
  handleAddStockGroupDetails,
  editStockGroupDetailsData,
  handleEditStockGroupDetails,
  handleResetEditData,
  toggleAddStockGroupModals,
  dispatchGetListStockGroup,
  token,
  stockGroupList,
  dispatchResetGroupList,
}: AppProps) => {
  const [toShowParentStockGroup, settoShowParentStockGroup] =
    useState<boolean>(false);
  const [quantitiesRadio, setQuanitiesRadio] = useState(RADIO_OPTIONS[0].id);
  const [stockGroupDetails, setStockGroupDetails] = useState({
    stockGroupName: "",
  });

  const [finalClientList, setFinalClientList] = useState<any>([]);
  const [selecteStockGroup, setSelecteStockGroup] = useState<clientListType>({
    value: null,
    label: "Select Stock Group...",
  });
  const [clientId, setClientId] = useState<any>("");
  const toggleCheckbox = () => {
    settoShowParentStockGroup(!toShowParentStockGroup);
  };
  const [onCancel, setOnCancel] = useState(isOpen);

  const [stockGroupDetailsError, setStockGroupDetailsError] = useState({
    stockGroupNameError: "",
  });

  const handleSetRadioValue = (radioValue: string) => {
    setQuanitiesRadio(radioValue);
  };

  const handleStockDetailsChange = (e: any) => {
    setStockGroupDetails((prevState) => ({
      ...prevState,
      stockGroupName: e.target.value,
    }));
    if (e.target.value) {
       setStockGroupDetailsError((prevState) => ({
        ...prevState,
        stockGroupNameError: "",
      }));
    }
  };

  const [finalStockGroupList, setFinalStockGroupList] = useState<any>([]);

  useEffect(() => {
    if (isEdit) {
      if (stockGroupList && stockGroupList?.length > 0) {
        editHandleManipulateStockGroupListData(stockGroupList);
      }
    } else {
      if (stockGroupList && stockGroupList?.length > 0) {
        addHandleManipulateStockGroupListData(stockGroupList);
      }
    }
     //eslint-disable-next-line
  }, [stockGroupList, isEdit]);

  let finalOptions: any = finalStockGroupList?.map((e: any) => {
    return {
      value: e.stock_group_id,
      label: e.stock_group_name,
      count:e.count
    }
  })
  // Recussively manipulating stock group data to populate in dropdown
  const addHandleManipulateStockGroupListData = (
    stockGroupData: any,
    finalStockData: any = []
  ) => {
    let count = 0;
    function getAllData(arr: any) {
      arr.map((e: any, i: number) => {
        if (count > 0) {
          finalStockData.push({
            stock_group_name: e?.stock_group_name.trim(),
            stock_group_id: e?.stock_group_id,
            count,
          });
        } else {
          finalStockData.push({
            stock_group_name: e?.stock_group_name.trim(),
            stock_group_id: e?.stock_group_id,
          });
        }
        if (e.is_tree == 1) {
          count++;
          getAllData(e.tree_data);
          count--;
        }
      });
    }

    getAllData(stockGroupData);
    setFinalStockGroupList(finalStockData);
  };

  const editHandleManipulateStockGroupListData = (
    stockGroupData: any,
    finalStockData: any = []
  ) => {
    let count = 0;
    function getAllData(arr: any) {
      let new_arr = arr?.filter(
        (el: any) => el?.stock_group_id != editStockGroupDetailsData?.stock_group_id
        );
      new_arr.map((e: any, i: number) => {
        if (count > 0) {
          finalStockData.push({
            stock_group_name: e?.stock_group_name,
            stock_group_id: e?.stock_group_id,
            count,
          });
        } else {
          finalStockData.push({
            stock_group_name: e?.stock_group_name,
            stock_group_id: e?.stock_group_id,
          });
        }
        if (e.is_tree == 1) {
          count++;
          getAllData(e.tree_data);
          count--;
        }
      });
    }

    getAllData(stockGroupData);
    
    setFinalStockGroupList(finalStockData);
  };
  useEffect(() => {
    if (isEdit) {
      setStockGroupDetails((prv) => ({
        ...prv,
        stockGroupName: editStockGroupDetailsData?.stock_group_name,
      }));
      if (editStockGroupDetailsData?.parent_group_id) {
        settoShowParentStockGroup(true);

        setSelecteStockGroup({
          value: editStockGroupDetailsData.stock_group_name,
          label: finalStockGroupList?.filter(
            (el: any) =>
              el.stock_group_id == editStockGroupDetailsData?.parent_group_id
          )[0]?.stock_group_name,
        });

        setClientId(
          finalStockGroupList?.filter(
            (el: any) =>
              el.stock_group_id == editStockGroupDetailsData?.parent_group_id
          )[0]?.stock_group_id
        );
      }
      setQuanitiesRadio(
        editStockGroupDetailsData?.is_quantities_enabled === 0
          ? RADIO_OPTIONS[1].id
          : RADIO_OPTIONS[0].id
      );
    }
     //eslint-disable-next-line
  }, [isEdit, stockGroupList, finalStockGroupList]);

  useEffect(() => {
    if (client_code && token) {
      let finalData = {
        token,
        client_code,
      };
      dispatchGetListStockGroup(finalData);
    }
     //eslint-disable-next-line
  }, []);

  const handleSubmitStockGroupDetails = () => {
    const { stockGroupName } = stockGroupDetails;
    const { stock_group_id } = editStockGroupDetailsData;
    if (
      stockGroupDetails?.stockGroupName.trim().length>0
    ) {
      if (isEdit) {
        let finalEditData = {
          client_code,
          stock_group_name: stockGroupName.trim(),
          is_quantities_enabled: quantitiesRadio,
          parent_group_id: toShowParentStockGroup ? clientId : "",
          stock_group_id: stock_group_id,
        };
        handleEditStockGroupDetails(finalEditData);
        handleResetData();
      } else {
        let finalEditData = {
          client_code,
          stock_group_name: stockGroupName.trim(),
          is_quantities_enabled: quantitiesRadio,
          parent_group_id: clientId,
        };
        handleAddStockGroupDetails(finalEditData);
      }

     
    } else {
      setStockGroupDetailsError((prevState) => ({
        ...prevState,
        stockGroupNameError: "Stock name is required!",
      }));
    }
  };

  const handleResetData = () => {
    setStockGroupDetails((prevState) => ({
      ...prevState,
      stockGroupName: "",
    }));
    setFinalClientList([]);
    dispatchResetGroupList();
  };

  const handleChangeClient = (client: any) => {
    setClientId(client?.value);
    setSelecteStockGroup({
      label: client?.label,
      value: client?.value,
    });
  };

  const Option = (props: OptionProps<any, false>) => {
    return (
      <components.Option {...props}>
        <ul className={`ledger-list`}>
          <li
            style={{
              paddingLeft: `${
                props?.data?.count !== undefined ? props?.data?.count * 10 : "0"
              }px`,
            }}
          >
            <span
              className={
                props?.data?.count === undefined
                  ? ""
                  : "stock-nested-list no-show"
              }
            >
              {props?.data.label}
            </span>
          </li>
        </ul>
      </components.Option>
    );
  };

  return (
    <Modal isOpen={onCancel} toggle={() => setOnCancel(true)} size="lg">
      <ModalHeader className="pt-4 pl-4">
        {`${isEdit ? "Edit" : "Add"} Stock Group`}
      </ModalHeader>
      <ModalBody className="pl-4 pr-4" style={{ paddingLeft: "40px" }}>
        <>
          <form>
            <div className="form-group mt-3">
              <div style={{ width: "53%" }}>
                <label
                  htmlFor="stockGroupName"
                  className={stockGroupName ? "active" : ""}
                >
                  Stock Group Name
                </label>
                <input
                  type="text"
                  className={`form-control ${
                    !!stockGroupNameError ? "error-border" : null
                  }`}
                  name="stockGroupName"
                  value={stockGroupDetails?.stockGroupName}
                  onChange={(e) => handleStockDetailsChange(e)}
                  maxLength={150}
                  required
                />
                {!!stockGroupDetailsError.stockGroupNameError && (
                  <small className="text-danger">
                    {stockGroupDetailsError.stockGroupNameError}
                  </small>
                )}
              </div>
              <span className="input-length">
                {returnInputFieldLength(
                  stockGroupDetails?.stockGroupName?.length,
                  150
                )}
              </span>
            </div>
          </form>
          <div className="d-flex mt-3 mb-3">
            <Checkbox
              checked={toShowParentStockGroup}
              onPress={toggleCheckbox}
            />
            <small className="ml-2">Make this a sub stock group</small>
          </div>
          {toShowParentStockGroup && (
            <>
              <form className="mt-3">
                <span className="form-group">
                  <label
                    htmlFor="stockGroupNumber"
                  >
                    Select Parent Stock Group
                  </label>
                </span>
              </form>
              <div className="ledger-dropdown" style={{ width: "53%" }}>
                <Select<any, false>
                  classNamePrefix="react-select"
                  inputProps={{ autoComplete: "nope" }}
                  options={finalOptions}
                  className={`react-select`}
                  value={selecteStockGroup}
                  onChange={handleChangeClient}
                  isSearchable
                  components={{ Option }}
                />
              </div>
            </>
          )}
        </>
        <form className="mt-3">
          <span className="form-group">
            <label
              htmlFor="stockGroupNumber"
            >
              Should quantities of items be added?
            </label>
          </span>
        </form>
        <div className="mt-2 mb-4">
          <RadioContainer
            optionsList={RADIO_OPTIONS}
            handleSetRadioValue={handleSetRadioValue}
            radioValue={quantitiesRadio}
          />
        </div>
      </ModalBody>
      <ModalFooter>
        <span
          className="pointer"
          onClick={() => {
            handleResetEditData();
            handleResetData();
            toggleAddStockGroupModals();
            setOnCancel(!onCancel);
          }}
        >
          Cancel
        </span>
        <Button
          color="primary ml-3"
          onClick={() => handleSubmitStockGroupDetails()}
          disabled={
            (toShowParentStockGroup && selecteStockGroup.value == null) ||
            stockGroupDetails.stockGroupName.length === 0
          }
        >
          {isEdit ? "Update Details" : "Add Details"}
        </Button>
      </ModalFooter>
    </Modal>
  );
};
const mapStateToProps = (state: RootState) => ({
  token: state.auth.token,
  stockGroupList: state.clientSettings.groupParentStockList,
});

const mapDispatchToProps = (dispatch: any) => ({
  dispatchGetListStockGroup: (data: getAllTypesParentStockGroupType) =>
    dispatch(getAllTypesParentStockGroupAction(data)),
  dispatchResetGroupList: () => dispatch(resetStockGroupList()),
});
export default connect(
  mapStateToProps,
  mapDispatchToProps
)(AddEditStockGroupModal);
